import FilterConstants from '../filter-constants';
import * as Format from './format';
import { camelize } from '@ember/string';
import ENV from '../config/environment';
import * as Context from './context';

let exitTabEvents = {
  'filter-type': 'filter type',
  specifications: 'specPageExit',
  components: 'compSelExit',
  tolerances: 'compTolExit',
};

let getElapsedInformation = function (currTime, startTime) {
  let endDateTime = new Date(currTime),
    startDateTime = new Date(startTime),
    deltaLoadTime = currTime - startTime;

  return 'startDate: ' + startDateTime + ', endDate: ' + endDateTime + ', loadTime(ms): ' + deltaLoadTime;
};

let getOpAmpsSorted = function (stages, order) {
  let result = [];
  for (let i = 0; i < order.length; i++) {
    for (let j = 0; j < stages.length; j++) {
      if (order[i] === j) {
        result.push(stages[j].opAmp);
        break;
      }
    }
  }
  return result;
};

export function sendTabExitAnalytics(modelData, inputType, analytics /*, logger*/) {
  let eventName = null;
  let payloadText = null;
  if (inputType) {
    eventName = exitTabEvents[inputType];
    let inputData = modelData.inputs[camelize(inputType)];
    switch (camelize(inputType)) {
      case FilterConstants.tabs.filterType: {
        payloadText = inputData;
        break;
      }
      case FilterConstants.tabs.specifications: {
        let filterType = modelData.inputs[FilterConstants.tabs.filterType];
        let resultData = modelData.results.get(camelize(inputType));
        let passbandFreq = Format.formatFieldValue(
          inputData.passbandFrequency,
          FilterConstants.fieldTypes.Engineering,
          '3s',
        );
        let nthOrder = resultData.nthOrder;
        let ordinal = nthOrder === 1 ? 'st' : nthOrder === 2 ? 'nd' : nthOrder === 3 ? 'rd' : 'th';
        let responseType = inputData.selectedResponseType;
        let responseValue = inputData.filterResponseValue > 0 ? inputData.filterResponseValue.toString() : '';
        let numStages = resultData.numberOfStages;
        payloadText =
          filterType +
          ' ' +
          passbandFreq +
          ' ' +
          nthOrder +
          ordinal +
          ' order ' +
          responseType +
          ' ' +
          responseValue +
          (responseValue ? ' (' : '(') +
          numStages +
          (numStages > 1 ? ' stages)' : ' stage)');
        break;
      }
      case FilterConstants.tabs.components: {
        payloadText =
          '+Vs=' +
          inputData.vsPlus +
          ' -Vs=' +
          inputData.vsMinus +
          ' ' +
          inputData.optimizationPreference +
          inputData.optimization;
        break;
      }
      case FilterConstants.tabs.tolerances: {
        payloadText =
          inputData.capacitorTolerance +
          ' ' +
          inputData.resistorTolerance +
          ' ' +
          inputData.inductorTolerance +
          ' ' +
          inputData.opAmpGbwTolerance +
          ' ' +
          inputData.capacitorPreferredSeries +
          ' ' +
          inputData.resistorPreferredSeries +
          ' ' +
          inputData.inductorPreferredSeries;
        break;
      }
      default:
        break;
    }
  }

  if (typeof eventName !== 'undefined' && eventName !== null) {
    analytics.setWebEvent(ENV.toolname, eventName, payloadText);
    //logger.log("Analytics. \nEvent Name: '" + eventName + "'\nPayload: '" +  payloadText + "'");
  }
}

export function sendTabNavigationAnalytics(oldTab, newTab, trigger, analytics /*, logger*/) {
  if (oldTab && trigger) {
    let eventName = 'navigation';
    let payloadText = (trigger === 'TAB' ? 'Button Bar: ' : 'Button Individual: ') + oldTab + ' to ' + newTab;
    analytics.setWebEvent(ENV.toolname, eventName, payloadText);
    //logger.log("Analytics. \nEvent Name: '" + eventName + "'\nPayload: '" +  payloadText + "'");
  }
}

export function sendPartStageDataNextStepsAnalytics(model, analytics, intl) {
  let eventName = 'FinalResultsEnter';
  let stages = model.inputs.components.individualStageInputs;
  let order = model.inputs.components.sortOrder;
  let opAmpsList = getOpAmpsSorted(stages, order);
  let refStage = 'ref=' + model.results.components.needReferenceStage.toString();
  let payloadText =
    'Amps=' +
    opAmpsList.join(', ') +
    '; ' +
    refStage +
    '; ' +
    Context.tolerancesSummary(model.results.tolerances, intl, 'en-us');
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function sendOpenCloseDialogAnalytics(control, status, model, analytics, intl) {
  let eventName = control + (status === 'O' ? ' first click' : status === 'S' ? ' second click' : ' cancel');
  let stages = model.inputs.components.individualStageInputs;
  let order = model.inputs.components.sortOrder;
  let opAmpsList = getOpAmpsSorted(stages, order);
  let refStage = 'ref=' + model.results.components.needReferenceStage.toString();
  let payloadText =
    'Amps=' +
    opAmpsList.join(', ') +
    '; ' +
    refStage +
    '; ' +
    Context.tolerancesSummary(model.results.tolerances, intl, 'en-us');
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function sendLocaleChangeAnalytics(langFrom, langTo, analytics /*, logger*/) {
  let eventName = 'lang';
  let payloadText = langFrom + '_' + langTo;
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
  //logger.log("Analytics. \nEvent Name: '" + eventName + "'\nPayload: '" +  payloadText + "'");
}

export function saveDesignAnalytics(designName, designDescription, saveDate, analytics) {
  let eventName = 'save';
  let payload = {
    designName: designName,
    designDescription: designDescription,
    toolName: ENV.toolname,
    saveDate: saveDate,
  };
  analytics.setWebEvent(ENV.toolname, eventName, JSON.stringify(payload));
}

export function loadDesignAnalytics(designData, analytics) {
  let eventName = 'load';
  let now = new Date();
  let loadDate =
    now.getFullYear() +
    '-' +
    ('0' + (now.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + now.getDate()).slice(-2) +
    ' ' +
    ('0' + (((now.getHours() + 11) % 12) + 1)).slice(-2) +
    ':' +
    ('0' + now.getMinutes()).slice(-2) +
    ':' +
    ('0' + now.getSeconds()).slice(-2) +
    ' ' +
    (now.getHours() >= 12 ? 'PM' : 'AM');
  let payload = {
    designName: designData.Name,
    designDescription: designData.Description,
    toolName: ENV.toolname,
    loadDate: loadDate,
  };
  analytics.setWebEvent(ENV.toolname, eventName, JSON.stringify(payload));
}

export function shareDesignAnalytics(description, sender, recipients, designData, analytics /*, logger*/) {
  let eventName = 'toolShare';
  let payload = {
    designDescription: description,
    senderName: sender,
    emailRecipients: recipients,
    projectData: designData,
  };
  analytics.setWebEvent(ENV.toolname, eventName, JSON.stringify(payload));
  //logger.log("Analytics. \nEvent Name: '" + eventName + "'\nPayload: '" +  JSON.stringify(payload) + "'");
}

export function downloadDesignAnalytics(event, model, analytics, intl) {
  let eventName = event;
  let stages = model.inputs.components.individualStageInputs;
  let order = model.inputs.components.sortOrder;
  let opAmpsList = getOpAmpsSorted(stages, order);
  let refStage = 'ref=' + model.results.components.needReferenceStage.toString();
  let payloadText =
    'Amps=' +
    opAmpsList.join(', ') +
    '; ' +
    refStage +
    '; ' +
    Context.tolerancesSummary(model.results.tolerances, intl, 'en-us');
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function loadTimeAnalytics(startDate, endDate, analytics) {
  let eventName = 'appLoad';
  let payloadText = getElapsedInformation(endDate, startDate);
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function loadDesignFailureAnalytics(errorDetails, analytics) {
  let eventName = 'Load Design Error';
  let payloadText = errorDetails + ' in design no longer supported';
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function toolbarLinkClickAnalytics(menuLink, activeTab, analytics) {
  let eventName = 'Toolbar Link';
  let payloadText = `${menuLink}; ${activeTab}`;
  analytics.setWebEvent(ENV.toolname, eventName, payloadText);
}

export function loadCDPAnalytics(step, options, analytics) {
  let eventName = 'CDP Load ' + step;
  let payload = {};
  if (options.sId) {
    payload['sId'] = options.sId.substr(0, 8);
  }
  if (options.reqId) {
    payload['reqId'] = options.reqId.substr(0, 8);
  }
  if (options.name) {
    payload['name'] = options.name;
  }
  if (options.url) {
    payload['url'] = options.url;
  }
  if (options.status) {
    payload['status'] = options.status.code;
    payload['statusText'] = options.status.message;
  }
  if (options.timeStart) {
    if (options.timeEnd) {
      payload['time'] = options.timeEnd - options.timeStart;
      payload['stamp'] = options.timeEnd.toISOString();
    } else {
      payload['stamp'] = options.timeStart.toISOString();
    }
  }
  analytics.setWebEvent(ENV.toolname, eventName, JSON.stringify(payload));
}
